module.exports = __webpack_public_path__ + "static/icon-handle.38485604.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/icon-handle.png
// module id = 274
// module chunks = 2